import {useEffect} from 'react';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {$getSelection, $isRangeSelection, PASTE_COMMAND, COMMAND_PRIORITY_HIGH} from 'lexical';

/** Paste is plain text only. */
export default function PastePlugin() {
  const [editor] = useLexicalComposerContext();
  useEffect(
    () =>
      editor.registerCommand(
        PASTE_COMMAND,
        (event) => {
          const data = event.clipboardData;
          if (!data) return false;
          event.preventDefault();
          const text = data.getData('text/plain');
          editor.update(() => {
            const sel = $getSelection();
            if ($isRangeSelection(sel) && text) sel.insertRawText(text);
          });
          return true;
        },
        COMMAND_PRIORITY_HIGH
      ),
    [editor]
  );
  return null;
}
